/* eslint-disable @typescript-eslint/no-unused-vars */
// import { useRecoilState } from 'recoil';
import { Action, BrokenEyeIcon, BrokenGclose } from '../../../assets/Icons';
// import { Action, BrokenEyeIcon, BrokenGclose, CheckIcon, GreenDot } from '../../../assets/Icons';
import { CustomPopover } from '../../../components/atoms';
import { ActionCON } from '../../style';
import { useNavigate } from 'react-router-dom';
import { useMemo, useState } from 'react';
import { useMutationHook } from '../../../network/mutations/useMutationHook';
import { deleteProduct } from '../../../network/services/admin/goods';
import { useQueryClient } from 'react-query';

export const ProductActions = ({ product }: any) => {
  const [value, setValue] = useState<HTMLElement | null>(null);
  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const handleOpen = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    console.log(value);
    if (value != null) {
      setValue(null);
    } else {
      setValue(event.currentTarget);
    }
  };

  const onViewDetailsSelect = (id?: any) => {
    navigate(`/admin/products/details/${product}`);
  };

  const { mutateAsync } = useMutationHook(deleteProduct);

  const _delete = async (id: number) => {
    try {
      await mutateAsync(id);
      queryClient.invalidateQueries('admin_products');
    } catch (error: any) {}
  };

  const options = [
    {
      label: 'View details',
      value: 'View details',
      Icon: BrokenEyeIcon,
      handleAction: onViewDetailsSelect
    },

    {
      label: 'Delete',
      value: 'Delete',
      Icon: BrokenGclose,
      color: '#D90429',
      handleAction: _delete
    }
  ];

  // useMemo(() => {}, []);
  return (
    <div>
      <ActionCON aria-describedby="product-action" onClick={event => handleOpen(event)}>
        <Action />
        <CustomPopover item={product} id="product-action" open={value} options={options} />
      </ActionCON>
    </div>
  );
};
